// extracted by mini-css-extract-plugin
module.exports = {"card":"CardLeadership_card__f0lUO","footer":"CardLeadership_footer__DAwWr","action":"CardLeadership_action__i0eIN"};